import * as React from 'react'

import NineBoxTooltip from './NineBoxTooltip'

const IDENTIFIED_REPORTS = {
  reports_competence_9box: 'reports_competence_9box',
}
interface Props {
  reportIdentifier: string
}

const TooltipInfo = ({ reportIdentifier }: Props) =>
  React.useMemo(() => {
    switch (reportIdentifier) {
      case IDENTIFIED_REPORTS.reports_competence_9box:
        return <NineBoxTooltip />

      default:
        return null
    }
  }, [reportIdentifier])

export default TooltipInfo
